<template>
    <section class="header" :class="{'header-open-search': openSearchAllowed}">
        <div class="menu-logo-bars">
            <div class="logo-top">
                <router-link to="/">
                    <img height="40" :src="logo" />
                </router-link>
            </div>
            <div class="menu-mobile">
                <div class="btn-menu">
                    <button type="button" @click="menuToggle">
                        <i class="far fa-bars" />
                    </button>
                </div>
                <div class="logo">
                    <router-link to="/">
                        <img height="40" :src="logo" />
                    </router-link>
                </div>
            </div>
        </div>
        <ui-menu />
        <ui-message-modal />
        <div class="menu-rigth">
            <div v-if="openSearchAllowed" class="menu-rigth-search">
                <ui-open-search />
            </div>
            <div class="menu-rigth-user">
                <div class="short-cuts">
                    <shortcuts :content="content" />
                </div>
                <div class="user-alerts" :class="{'user-alerts-mobile': mobile}">
                    <Alerts />
                    <div v-if="sidebar" class="activies-toggle">
                        <button type="button" @click="sidebarToggle">
                            <i class="fal fa-comment-alt-lines" />
                        </button>
                    </div>
                    <User :mobile="mobile" />
                </div>
            </div>
        </div>
        <ui-global-modals />
    </section>

</template>
<script>
    import uiMenu from '../panel-menu'
    import Shortcuts from '../fast-menu'
    import Alerts from '../alerts'
    import User from '../user-logged'
    import { storage } from '@/services/storage'
    import uiOpenSearch from '@/components/ui/open-search'
	import { uiGlobalModals } from '@/components/ui-facilita/modals'
    import { uiMessageModal } from '@/components/ui-facilita/modals'

	export default {
        name: 'ui-panel-header',

        components: { uiMenu, Alerts, Shortcuts, User, uiOpenSearch, uiGlobalModals, uiMessageModal},

        props:{
            sidebar: {
                type: Boolean,
                default: true
            }
		},

        data() {
            return {
                logo: null,
                getUser: null,
                betaFeatures: null,
                windowWidth: window.innerWidth
            }
        },

        computed: {
			isDynamicUser() {
				return (this.getUser && this.getUser.isDynamicGroup) ? true : false
			},

			openSearchAllowed() {
				return (
					this.betaFeatures &&
						this.betaFeatures.opensearch &&
							this.betaFeatures.opensearch[this.getUser.user_group]) == 1 || (this.isDynamicUser && this.betaFeatures.opensearch['dynamic'] == 1)
			},

            content() {
                return this.windowWidth < 651 ? '<i class="fas fa-caret-down"></i>' : 'Selecione <i class="fas fa-caret-down"></i>'
            },

            mobile() {
                return this.windowWidth < 651 ? true : false
            }
        },

        beforeDestroy() {
            window.removeEventListener('resize', this. handleWindowResize)
        },

        mounted() {
            window.addEventListener('resize', this.handleWindowResize)
        },

        created(){
            this.getUser = JSON.parse(storage.get('user_logged'))
            this.betaFeatures = JSON.parse(storage.get('beta_features'))
            this.logo = storage.get('client_logo') + "?v=1"
        },

        methods: {
            sidebarToggle(){
                this.$root.$emit("sidebar-activities-toggle");
            },
            menuToggle(){
                this.$root.$emit("menu-toggle");
            },
            handleWindowResize(event) {
                this.windowWidth = event.currentTarget.innerWidth;
            },
        }
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl';

</style>
